<template>
  <v-list nav dense>
    <v-subheader>
      <strong>{{ companyName }}</strong>
    </v-subheader>
    <template v-if="isInAccountContext">
      <account-side-menu />
    </template>

    <v-divider v-if="getAuthedAccounts.length > 1" />
    <ferro-menu-item
      v-if="isBrokerageUser || getAuthedAccounts.length > 1"
      title="Switch Account"
      icon="mdi-account-switch"
      @click="switchAccount()"
      :route="false"
      :route-name="ROUTES.ACCOUNT_SELECTOR"
    />
  </v-list>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as routes from '@/router/route-names'
import AccountSideMenu from '@/components/sidemenu/AccountSideMenu'
import BrokerageSideMenu from '@/components/sidemenu/BrokerageSideMenu'
import FerroMenuItem from '@/components/sidemenu/FerroMenuItem'

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { AccountSideMenu, BrokerageSideMenu, FerroMenuItem },
  created() {
    this.ROUTES = routes
  },
  computed: {
    ...mapGetters({
      getAuthedAccounts: 'getAuthedAccounts',
      getActiveAccount: 'getActiveAccount',
      isBrokerageAdmin: 'isBrokerageAdmin',
      isBrokerageUser: 'isBrokerageUser',
      isAnAdmin: 'isAnAdmin',
    }),
    isInAccountContext() {
      return this.accountCode !== undefined
    },
    accountCode() {
      return this.getActiveAccount?.accountCode
    },
    companyName() {
      return this.getActiveAccount?.companyName
    },
  }, // end computed
  methods: {
    ...mapActions({
      setActiveAccount: 'setActiveAccount',
      logout: 'logout',
    }),
    goTo(page) {
      this.$router
        .push({
          name: page,
          params: { accountId: this.accountCode },
        })
        .catch(e => {
          if (this.accountCode === undefined) {
            console.error('ROUTING-SIDE_MENU', page, e.message)
          }
        })
    },

    goToPageWithoutAccountProp(page) {
      this.$router
        .push({
          name: page,
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {})
    },

    goToDashboardUnderwriting() {
      this.goTo(routes.DASHBOARD)
    },
    //  params: { accountId: this.accountCode, tab: 'underwriting'}
    // params: { accountId: this.accountCode, tab: 'riskManagement'}
    //
    goToDashboardRiskManagement() {
      this.goTo(routes.DASHBOARD_RISK_MANAGEMENT)
    },
    goToPolicies() {
      this.goTo(routes.POLICY_ADMIN)
    },
    goToDocuments() {
      this.goTo(routes.DOCUMENTS)
    },
    switchAccount() {
      this.setActiveAccount({ accountCode: undefined })
      this.goTo(routes.ACCOUNT_SELECTOR)
    },
    signOut() {
      this.logout()
      this.goTo(routes.LOGIN_PAGE)
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .v-subheader {
  height: auto !important;
  min-height: 40px !important;
}
</style>
